module.exports = __webpack_public_path__ + "static/media/4-min.aa8a0d2e.jpg";